import React, { useState, useEffect } from 'react';
import { mediaUrl } from '../../../utils/mediaUrl';
import { logEvent } from '../../../utils/analytics';

const hideOnError = (e) => {
  e.target.onerror = null; // 防止無限循環
  e.target.style.display = 'none'; // 隱藏無法載入的圖片
};

const avatarErrorFallback = (e) => {
  e.target.onerror = null;
  e.target.removeAttribute('src'); // 保留 .avatar 灰底佔位，而非整個消失
};

const ImageMessage = ({ message, avatarSrc, memberId }) => {
  const { content, imagePath, imagePaths, timestamp } = message;
  const [lightbox, setLightbox] = useState(null);
  const openLightbox = (path) => {
    logEvent('media_view', { media_type: 'image', member_id: memberId });
    setLightbox(path);
  };
  const avatarUrl = mediaUrl(avatarSrc);

  // 優先用 imagePaths（多圖），沒有則 fallback 回單數 imagePath（向後相容）。
  const paths = (imagePaths && imagePaths.length > 0)
    ? imagePaths
    : (imagePath ? [imagePath] : []);
  const isMulti = paths.length > 1;

  // lightbox 開啟時，Escape 鍵可關閉。
  useEffect(() => {
    if (lightbox === null) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setLightbox(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox]);

  // 多圖網格欄數：最多 3 欄，2 張時用 2 欄避免留白。
  const galleryColumns = Math.min(paths.length, 3);

  return (
    <div className="message">
      <img
        className="avatar"
        src={avatarUrl || undefined}
        alt="成員頭像"
        onError={avatarErrorFallback}
      />
      <div className="message-content">
        <div className="message-text">
          {content && content.split('\n').map((text, index) => (
            <React.Fragment key={index}>
              {text}
              {index < content.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
          {paths.length > 0 && (
            <div
              className={isMulti ? 'message-image-gallery' : ''}
              style={isMulti ? { gridTemplateColumns: `repeat(${galleryColumns}, 1fr)` } : undefined}
            >
              {paths.map((path, index) => (
                <img
                  key={index}
                  className={isMulti ? 'message-image-thumb' : 'message-image'}
                  src={mediaUrl(path)}
                  alt={isMulti ? `訊息圖片 ${index + 1}` : '訊息圖片'}
                  role="button"
                  tabIndex={0}
                  onClick={() => openLightbox(path)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      openLightbox(path);
                    }
                  }}
                  onError={hideOnError}
                />
              ))}
            </div>
          )}
        </div>
        <div className="timestamp">{timestamp}</div>
      </div>

      {lightbox !== null && (
        <div
          className="message-lightbox"
          onClick={() => setLightbox(null)}
        >
          <img
            src={mediaUrl(lightbox)}
            alt="訊息圖片"
            className="message-lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="message-lightbox-close"
            onClick={() => setLightbox(null)}
            aria-label="關閉"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageMessage;
